import { createFileRoute } from "@tanstack/react-router";
import PoliticaConfidentialitate from "@/pages/legal/PoliticaConfidentialitate";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/politica-de-confidentialitate/")({
  head: () => routeHead("/politica-de-confidentialitate/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PoliticaConfidentialitate />
  );
}
